import React from "react";

const About = () => {
  return (
    <div
      name="about"
      className="w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white">
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            About
          </p>
        </div>

        <p className="text-xl mt-20">
          I'm very ambitious front-end developer looking for a role in
          established IT company with the opprtunity to work with the latest
          technologies on challenging and diverse projects!
        </p>

        <br />

        <p className="text-xl">
          Self-motivated professional with ability to quickly master new
          technology to drive process improvements. Strong team player with
          excellent communication and collaborative abilities. <br />
          3+ years of experience writing code as polyglot programmer.
        </p>
      </div>
    </div>
  );
};

export default About;
